/* eslint-disable react/prop-types */
import React from "react";

const Container = (props) => {
  return (
    <div
      className={`container mx-auto px-4 py-8 lg:px-8 xl:px-0 ${
        props.className ? props.className : ""
      }`}
    >
      {props.children}
    </div>
  );
};

export default Container;
